<template>
    <b-modal v-model="show" :title="title" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid pl-0 pr-0">
            <div class="row">
                <div class="col">
                    <div class="card">
                        <div class="card-body">
                            <div class="scrollable">
                                <p class="card-text">{{data}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn float-right mr-2" @click="close">
                Чиқиш
            </button>
        </div>
    </b-modal>
</template>

<script>

    import bModal from 'bootstrap-vue/es/components/modal/modal';
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal';

    export default {
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        props: {
            data: {
                type: Object,
                default: null
            },
            title: {
                type: String,
                default: 'Modal view'
            }
        },
        data() {
            return {
                show: false
            }
        },
        methods: {
            close() {
                this.show = false
            }
        },
        created() {
            this.$eventBus.$on("showBaseModal", () => {
                this.show = true
            })
        }
    }
</script>

<style scoped>
    .card-text {
        white-space: pre-line;
    }
    .card{
        width: 100%;
    }
    .scrollable{
        overflow: auto;
        max-height: 300px;
    }
</style>